if (typeof Swiper !== 'undefined') {
  document.addEventListener('DOMContentLoaded', function () {
    const gallerySliders = document.querySelectorAll('[data-social-gallery-slider]');

    gallerySliders.forEach(function (sliderElement) {
      const mode = sliderElement.dataset.mode || 'loop';
      const isLoopMode = mode === 'loop';
      const autoplaySpeed = parseInt(sliderElement.dataset.autoplaySpeed) || 8;

      // Base configuration
      const swiperConfig = {
        slidesPerView: 'auto',
        spaceBetween: 0,
        grabCursor: true,
        mousewheel: {
          forceToAxis: true,
        },
        breakpoints: {
          0: {
            slidesPerView: 'auto',
            spaceBetween: 0
          },
          750: {
            slidesPerView: 'auto',
            spaceBetween: 0
          }
        }
      };

      // Add loop-specific configuration
      if (isLoopMode) {
        swiperConfig.loop = true;
        swiperConfig.loopedSlides = 5;
        swiperConfig.autoplay = {
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: sliderElement.dataset.hoverPlay === 'true' // Check if hover play is enabled
        };
        swiperConfig.speed = autoplaySpeed * 1000; // Convert seconds to milliseconds
        swiperConfig.freeMode = {
          enabled: true,
          momentum: false
        };
      } else {
        // Static mode configuration
        swiperConfig.freeMode = true;
        swiperConfig.autoplay = false;
      }

      new Swiper(sliderElement, swiperConfig);
    });
  });
} else {
  console.warn('Swiper library not loaded. Please include Swiper JS library in your theme.');
}